module.exports = __webpack_public_path__ + "img/sale.1eaf67df.svg";